module.exports = __webpack_public_path__ + "img/indicadores.bfd44bbc.svg";